module.exports = __webpack_public_path__ + "img/nengli.6cbbbefe.png";